import React from 'react';
import { useQuery } from 'react-apollo-hooks';
import { AccountContext } from '../../../../../context/account';
import { accountMembersQuery } from '../../../../../queries/account';
import {
  AccountMembersQuery,
  AccountMembersQueryVariables
} from '../../../../../queries/__generated__/AccountMembersQuery';
import { Modal } from '../../../../ui';
import { ErrorScreen, Loading } from '../../../../utils';
import HasAvailableMembers from './HasAvailableMembers';
import NoAvailableMembers from './NoAvailableMembers';

interface AddMemberToGroupModal {
  closeModal: () => void;
  group: {
    id: string;
    name: string;
    slug: string;
  };
  groupMembers: {
    id: string;
    member: {
      id: string;
      user: {
        id: string;
      };
    };
  }[];
}

const AddMemberToGroupModal: React.FC<AddMemberToGroupModal> = ({
  closeModal,
  group,
  groupMembers
}) => {
  const accountContext = React.useContext(AccountContext);

  const { data, loading, error } = useQuery<AccountMembersQuery, AccountMembersQueryVariables>(
    accountMembersQuery,
    { variables: { input: { accountId: accountContext.selectedAccountId } } }
  );
  if (loading) return <Loading />;
  if (error) return <ErrorScreen error={error.message} />;

  const groupMemberIds = groupMembers.map(({ member }) => member.user.id);
  const accountMembers = data!.accountMembers;
  const filteredAccountMembers = accountMembers
    .filter(member => member.membershipStatus !== 'INACTIVE')
    .filter(member => !groupMemberIds.includes(member.user.id));

  return (
    <Modal closeModal={closeModal}>
      {filteredAccountMembers.length === 0 ? (
        <NoAvailableMembers />
      ) : (
        <HasAvailableMembers
          closeModal={closeModal}
          group={group}
          members={filteredAccountMembers}
        />
      )}
    </Modal>
  );
};

export default AddMemberToGroupModal;
